import React, { SVGProps } from 'react';

const ChevronLeftIcon: React.FC<
  SVGProps<{ fill?: string; fontSize?: number }>
> = ({ fill = '#1A212A', fontSize = 16 }) => {
  return (
    <svg
      fill='none'
      height={fontSize}
      viewBox='0 0 11 16'
      width={fontSize}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.33523 7.98652L10.6943 14.5462C10.8889 14.6989 10.9862 14.8898 10.9862 15.1188C10.9862 15.3479 10.8889 15.5457 10.6943 15.7123C10.482 15.8789 10.2299 15.9622 9.938 15.9622C9.6461 15.9622 9.394 15.8789 9.1817 15.7123L0.451124 8.86114C0.291904 8.73619 0.176911 8.59737 0.106147 8.44465C0.0353823 8.29194 0 8.13923 0 7.98652C0 7.83381 0.0353823 7.6811 0.106147 7.52839C0.176911 7.37568 0.291904 7.23685 0.451124 7.1119L9.20824 0.239896C9.42053 0.0733014 9.66821 -0.00652494 9.95127 0.000416485C10.2343 0.00735791 10.482 0.0941257 10.6943 0.26072C10.8889 0.427314 10.9906 0.621674 10.9995 0.843799C11.0083 1.06592 10.9066 1.26028 10.6943 1.42688L2.33523 7.98652Z'
        fill={fill}
      />
    </svg>
  );
};

export default ChevronLeftIcon;
